import { withI18n } from '@squareup/service-i18n/components';
import { type ProductPageHeaderProps, ProductPageHeader } from './ProductPageHeader';
import styles from './ProductPageHeader.module.scss';

export const ProductPageHeaderSecondary = ({
  ...props
} : ProductPageHeaderProps) => {
  const {
    buttons, buttonDropdown,
  } = props;
  const hasButtons = buttons?.length || buttonDropdown;
  const shouldCenterTitle = !hasButtons;
  const headerClassName = `${shouldCenterTitle ? styles.headerSecondaryCentered : styles.headerSecondarySpread}`;

  return (
    <ProductPageHeader {...props} secondaryClassName={headerClassName} shouldCenterTitle={shouldCenterTitle} />
  );
};

export const ProductPageHeaderSecondaryI18n = withI18n(ProductPageHeaderSecondary);
